import script from "./GolfInviteForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./GolfInviteForm.vue?vue&type=script&lang=ts&setup=true"

import "./GolfInviteForm.vue?vue&type=style&index=0&id=c7282232&lang=scss&scoped=true"

import exportComponent from "/builds/rentalcar-app/admin-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7282232"]])

export default __exports__